var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getParticipantsWithPastShiftsFunctionDef } from '../../../../backend/features/shift/shared';
import { defaultFetcherOptions } from '../../../../ui/utils/defaultFetcherOptions';
import { handleErrorSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useTypedPlatformFunction } from '@juvare/platform-sdk-react/ui/features/typed-platform-functions';
import { useCallback } from 'react';
import useSWR from 'swr';
export const participantsWithPastShiftsFetchKey = 'participantsWithPastShifts';
export const useParticipantsWithPastShifts = ({ filterData, limit, offset }) => {
    const getParticipantsWithPastShiftsPlatformFn = useTypedPlatformFunction(getParticipantsWithPastShiftsFunctionDef);
    const fetchParticipantsWithPastShifts = () => {
        return getParticipantsWithPastShiftsPlatformFn({
            filterData,
            limit,
            offset,
        });
    };
    const { data: listData, mutate, isLoading, error, } = useSWR([participantsWithPastShiftsFetchKey, limit, offset, filterData], () => fetchParticipantsWithPastShifts().catch(handleErrorSnackbar), defaultFetcherOptions);
    const fetchShiftsParticipants = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        yield mutate();
    }), [mutate]);
    return {
        fetchShiftsParticipants,
        shiftsParticipants: listData === null || listData === void 0 ? void 0 : listData.rows,
        total: listData === null || listData === void 0 ? void 0 : listData.total,
        analytics: listData === null || listData === void 0 ? void 0 : listData.analytics,
        error,
        isLoading,
    };
};
